import React from "react";
import {twMerge} from 'tailwind-merge'

export default function Button({
                                   clickHandler,
                                   text,
                                   subtext = null,
                                   outline = false,
                                   className,
                                   ...rest
                               }) {

    var priveClassName = "bg-[#f9b712] text-black w-full h-12 rounded-[10px] font-bold text-[16px] disabled:opacity-40";
    if (outline) {
        priveClassName = "bg-transparent border-2 border-[#f9b712] text-[#f9b712] w-full h-12 rounded-[10px] font-bold text-[16px] disabled:opacity-40";
    }

    // merge classes : https://www.youtube.com/watch?v=tfgLd5ZSNPc
    return (
        <button
            {...rest}
            className={twMerge(className, priveClassName)}
            type="button"
            onClick={clickHandler}
        >
            <div>
                <div>{text}</div>
                {subtext != null ?
                    <div className="text-sm mt-[-8px]">{subtext}</div>
                    : null}
            </div>
        </button>
    );
}